import { _baseGetFetch, _basePutFetch } from './baseFetch'

const Limit = 10

export const getCycleFaultProducts = (baseParams) => {
  return _baseGetFetch('/cycles/faults', baseParams)
}

export const getCyclesChart = (queryParams) => {
  return _baseGetFetch('/cycles/chart', queryParams)
}

export const getCyclesSummaryTotalCycles = (queryParams) => {
  return _baseGetFetch('/cycles/summary/total-cycles', queryParams)
}

export const getCyclesSummaryTotalCF = (queryParams) => {
  return _baseGetFetch('/cycles/summary/total-cycle-faults', queryParams)
}

export const getCyclesSummaryTotalPending = (queryParams) => {
  return _baseGetFetch('/cycles/summary/total-pending-action', queryParams)
}

export const getCyclesFaultsNotes = (serialNumber, queryParams) => {
  return _baseGetFetch(`/cycles/faults/${serialNumber}`, queryParams)
}

export const putCyclesFaultsStatus = (id, payload) => {
  return _basePutFetch(`/cycles/faults/${id}`, payload)
}

export const getAnalyticsFaultsOverview = (queryParams) => {
  return _baseGetFetch(`/analytics/faults/overview`, queryParams)
}

export const getAnalyticsFaultsCountries = (queryParams) => {
  return _baseGetFetch('/cycles/faults/countries', queryParams)
}

export const getAnalyticsFaultsCodes = (queryParams) => {
  return _baseGetFetch('/cycles/faults/codes', queryParams)
}

export const getAnalyticsFaultsSummary = async (queryParams) => {
  return _baseGetFetch('/analytics/faults/summary', queryParams)
}

export const getAnalyticsFaultsList = (queryParams) => {
  return _baseGetFetch('/analytics/faults/list', { ...queryParams, limit: Limit })
}

export const getAnalyticsFaultsListCsv = (queryParams) => {
  return _baseGetFetch('/analytics/faults/download', queryParams)
}

export const getAnalyticsFaultsCycleDetailsMonthly = async (queryParams) => {
  return _baseGetFetch('/analytics/faults/trend/monthly', queryParams)
}

export const getAnalyticsFaultsCycleDetailsDaily = async (queryParams) => {
  return _baseGetFetch('/analytics/faults/trend/daily', queryParams)
}

